<template>
    <div>
        <sites-form 
            :is-sites-form-sidebar-active.sync="isSitesFormSidebarActive"
            :sites-data="sitesData"
            :site-types="siteTypes"
            @refetch-data="refetchData"
        />
        <b-card no-body>
            <div class="m-2">
                <b-row>
                    <b-col
                        cols="12"
                        md="6"
                        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                    >
                    </b-col>
                    <b-col
                        cols="12"
                        md="6"
                    >
                        <div class="d-flex align-items-center justify-content-end">
                            <v-select
                                id="site_types_id"
                                class="d-inline-block width-350 mr-1"
                                v-model="siteTypesFilter"
                                placeholder="Filter By Site Type"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                label="title"
                                :reduce="(option) => option.id"
                                :options="siteTypesData.map(g => ({title: g.name, id: g.id}))"
                            />
                            <b-form-input
                                v-model="searchQuery"
                                class="d-inline-block mr-1"
                                placeholder="Search..."
                            />
                            <b-button
                                variant="primary"
                                @click="updateSite()"
                            >
                                <span class="text-nowrap">Add Site</span>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <table class="table table-striped">
                <thead>
                    <tr>
                    <th scope="col" v-for="col in tableColumns" :key="col.key">
                        {{col.label}}
                    </th>
                    </tr>
                </thead>
                <draggable v-if="sites.length > 0" v-model="sites" tag="tbody" hadle=".handle" >
                    <tr v-for="(item, index) in sites" :key="index">
                        <th scope="row" class="pl-2">
                            <feather-icon size="24" icon="MenuIcon"/>
                        </th>
                        <td class="pl-2">
                            <div v-html="item.name[currentLocale]"/>
                        </td>
                        <td class="pl-2">
                            <span>{{ item.domain }}</span>
                        </td>
                        <td class="pl-2">
                            <span>{{ item.type.name }} </span>
                        </td>
                        <td class="pl-2">
                            <b-badge
                                pill
                                :variant="`light-${resolveCatStatusVariant(item.is_active)}`"
                                class="text-capitalize"
                            >
                                {{ resolveCatStatusnameVariant(item.is_active) }} 
                            </b-badge>
                        </td>
                        <td class="pl-2">
                            <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'"  @click="updateSite(item)" variant="outline-success">Edit</b-button>
                            <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="ml-1" @click="deleteconfirm(item.id)" variant="outline-danger">Delete</b-button>
                        </td>
                    </tr>
                </draggable>
                <tbody v-else>
                    <tr>
                        <td colspan="6" class="text-center">
                            No matching records found
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="mx-2 mb-2">
                <b-row>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                        <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
                    </b-col>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalSites"
                            :per-page="perPage"
                            first-number
                            last-number
                            class="mb-0 mt-1 mt-sm-0"
                            prev-class="prev-item"
                            next-class="next-item"
                        >
                            <template #prev-text>
                                <feather-icon
                                    icon="ChevronLeftIcon"
                                    size="18"
                                />
                                </template>
                                <template #next-text>
                                <feather-icon
                                    icon="ChevronRightIcon"
                                    size="18"
                                />
                            </template>
                        </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>
    import {
        BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,BImg,
        BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,VBModal,BFormGroup,BFormCheckbox,BImgLazy
    } from 'bootstrap-vue'
    import Ripple from 'vue-ripple-directive'
    import store from '@/store'
    import { ref,onUnmounted } from '@vue/composition-api'
    import useSitesList from './useSitesList'
    import sitesStoreModule from '../sitesStoreModule'
    import sitesForm from '../sites-form/SitesForm.vue'
    import vSelect from 'vue-select'
    import draggable from 'vuedraggable'
    import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'

    export default {
        components:{
            BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
            BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup, BFormCheckbox,
            BImg, BImgLazy, draggable, vSelect, sitesStoreModule, sitesForm, FeatherIcon
        }, 

        directives:{
            'b-modal': VBModal,
            Ripple
        },

        computed: {
            currentLocale() {
                return  this.$i18n.locale;
            },
        },

        setup(){
            const SITE_STORE_MODULE_NAME = 'app-sites';
            if (!store.hasModule(SITE_STORE_MODULE_NAME)) store.registerModule(SITE_STORE_MODULE_NAME, sitesStoreModule)
            onUnmounted(() => {
                if (store.hasModule(SITE_STORE_MODULE_NAME)) store.unregisterModule(SITE_STORE_MODULE_NAME)
            });

            const {
                resolveCatStatusVariant,
                resolveCatStatusnameVariant,
                sitesData,
                isSitesFormSidebarActive,
                fetchData,
                refetchData,
                tableColumns,
                dataMeta,
                refSiteTypeListTable,
                totalSites,
                perPage,
                currentPage,
                searchQuery,
                sortBy,
                updateSitesOrdering,
                sites,
                t,
                isSortDirDesc,
                statusFilter,
                resolveSiteTypeStatusVariant,
                resolveSiteTypeStatusnameVariant,
                updateSite,
                deleteData,
                siteTypeData,
                siteTypeFilter,
                updateSiteOrdering,
                addSite,
                siteTypes,
                types,
                siteTypesFilter,
                siteTypesData,
            } = useSitesList();

            fetchData();

            // const titleLang = (data, currentLocale, type) => {
            //     const dataLang = data?.foodLang??[]
            //     return dataLang.find(t => t.lang === currentLocale)?.[type]??''
            // }
            
            return {
                resolveCatStatusVariant,
                resolveCatStatusnameVariant,
                sitesData,
                isSitesFormSidebarActive,
                refetchData,
                fetchData,
                tableColumns,
                dataMeta,
                totalSites,
                perPage,
                currentPage,
                searchQuery,
                sortBy,
                updateSitesOrdering,
                sites,
                t,
                refSiteTypeListTable,
                isSortDirDesc,
                statusFilter,
                resolveSiteTypeStatusVariant,
                resolveSiteTypeStatusnameVariant,
                updateSite,
                deleteData,
                siteTypeData,
                siteTypeFilter,
                updateSiteOrdering,
                addSite,
                siteTypes,
                types,
                siteTypesFilter,
                siteTypesData,
                // titleLang,
            }
        },

        methods:{
            deleteconfirm(id){
                this.$bvModal
                    .msgBoxConfirm('Please confirm that you want to delete Site ID.'+id, {
                        title: 'Please Confirm',
                        size: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Yes',
                        cancelTitle: 'No',
                        cancelVariant: 'outline-secondary',
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then(value => {
                    if(value === true){
                        this.deleteData(id)
                    }
                })
            },
        }
    }
</script>
    